<div class="modal">
  <div class="modal-content w-[630px] p-8 flex flex-col items-center">
    <div class="mb-6 flex justify-end w-full">
    </div>

    <div class="phone-validation">
      <h2><strong>Validar número de celular</strong></h2>
      <p>Digite abaixo o código enviado para {{phone}}</p>
      <div class="code-inputs">
        <input id="1" type="text" maxlength="1" (input)="moveFocus($event, '2')">
        <input id="2" type="text" maxlength="1" (input)="moveFocus($event, '3')">
        <input id="3" type="text" maxlength="1" (input)="moveFocus($event, '4')">
        <input id="4" type="text" maxlength="1">
  
      </div>
      <p *ngIf="invalidCode && !finalCode" style="margin-top: 25px"   class="red-code">Código inválido ou expirado</p>
      <p *ngIf="finalCode" style="margin-top: 25px" class="red-code">Máximo de tentativas de confirmação alcançada</p>

      <p (click)="notReceivePin()" *ngIf="notReceive" style="text-decoration: underline; color: blue; margin-top: 15px; padding: 5px; display: inline-block; cursor: pointer;">
        Não recebi / Não possuo acesso ao celular 
      </p>
    </div>

    <button style="margin-top: 15px;" (click)="checkPin()" class="btn__expansivel">Confirmar</button>
  </div>
</div>

<ftc-progresso *ngIf="loadingOn"></ftc-progresso>
